import Vue, { VueConstructor } from 'vue';

function _asyncWait<T>(this: Vue, cb: () => T): Promise<T> {
  return new Promise(resolve => {
    const unwatch = this.$watch<T>(
      cb,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (value: any) => {
        unwatch();
        resolve(value);
      },
    );
  });
}

let _vue: Vue | undefined;

export default function asyncWait<T>(cb: () => T): Promise<T> {
  if (!_vue) {
    _vue = new Vue();
  }
  return _asyncWait.call(_vue, cb) as Promise<T>;
}

class AsyncWhenPlugin {
  static install(VueCtr: VueConstructor) {
    Object.defineProperty(VueCtr.prototype, '$asyncWait', {
      value: _asyncWait,
    });
  }
}

declare module 'vue/types/vue' {
  interface Vue {
    /**
     * Waits on a one-off change from callback
     *
     * It is best to return a boolean, string or a number.
     */
    $asyncWait: typeof _asyncWait;
  }
}

Vue.use(AsyncWhenPlugin);
